<div class="password-dialog-backdrop" *ngIf="visible" (click)="close()">
  <section class="password-dialog" role="dialog" aria-modal="true" aria-label="Thay đổi mật khẩu" (click)="$event.stopPropagation()">
    <div class="password-dialog-header">
      <h3>Thay đổi mật khẩu</h3>
      <button type="button" class="password-close-btn" (click)="close()" aria-label="Đóng">×</button>
    </div>

    <div class="password-dialog-body">
      <label class="required-label">Mật khẩu hiện tại</label>
      <div class="password-input-wrap">
        <input
          [type]="showPasswordCurrent ? 'text' : 'password'"
          [(ngModel)]="passwordCurrent"
          [disabled]="submitting"
          placeholder="Nhập mật khẩu hiện tại"
          maxlength="50" />
        <button
          type="button"
          class="password-toggle-btn"
          (click)="togglePasswordVisibility('current')"
          [disabled]="submitting"
          [attr.aria-label]="showPasswordCurrent ? 'Ẩn mật khẩu hiện tại' : 'Hiện mật khẩu hiện tại'"
          [attr.aria-pressed]="showPasswordCurrent">
          <svg class="password-toggle-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path d="M2.5 12s3.5-7 9.5-7 9.5 7 9.5 7-3.5 7-9.5 7S2.5 12 2.5 12Z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" />
            <path d="M12 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z" fill="none" stroke="currentColor" stroke-width="1.8" />
            <path *ngIf="!showPasswordCurrent" d="M4 4l16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
          </svg>
        </button>
      </div>

      <label class="required-label">Mật khẩu mới</label>
      <div class="password-input-wrap">
        <input
          [type]="showPasswordNew ? 'text' : 'password'"
          [(ngModel)]="passwordNew"
          (input)="onPasswordNewInput()"
          [disabled]="submitting"
          placeholder="Nhập mật khẩu mới"
          [attr.maxlength]="passwordPolicy.maxLength"
          [attr.minlength]="passwordPolicy.minLength"
          pattern="(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,20}"
          autocomplete="new-password" />
        <button
          type="button"
          class="password-toggle-btn"
          (click)="togglePasswordVisibility('new')"
          [disabled]="submitting"
          [attr.aria-label]="showPasswordNew ? 'Ẩn mật khẩu mới' : 'Hiện mật khẩu mới'"
          [attr.aria-pressed]="showPasswordNew">
          <svg class="password-toggle-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path d="M2.5 12s3.5-7 9.5-7 9.5 7 9.5 7-3.5 7-9.5 7S2.5 12 2.5 12Z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" />
            <path d="M12 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z" fill="none" stroke="currentColor" stroke-width="1.8" />
            <path *ngIf="!showPasswordNew" d="M4 4l16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
          </svg>
        </button>
      </div>

      <div class="password-rules" aria-live="polite">
        <div class="password-rule" [class.valid]="passwordNewValid.length">8-20 ký tự</div>
        <div class="password-rule" [class.valid]="passwordNewValid.uppercase">Ít nhất 1 chữ hoa</div>
        <div class="password-rule" [class.valid]="passwordNewValid.number">Ít nhất 1 chữ số</div>
        <div class="password-rule" [class.valid]="passwordNewValid.special">Ít nhất 1 ký tự đặc biệt</div>
      </div>

      <div class="password-error" *ngIf="passwordNew && !isPasswordNewStrong()">Mật khẩu mới chưa đủ mạnh.</div>

      <label class="required-label">Nhập lại mật khẩu mới</label>
      <div class="password-input-wrap">
        <input
          [type]="showPasswordConfirm ? 'text' : 'password'"
          [(ngModel)]="passwordConfirm"
          [disabled]="submitting"
          placeholder="Nhập lại mật khẩu mới"
          [attr.maxlength]="passwordPolicy.maxLength"
          [attr.minlength]="passwordPolicy.minLength"
          autocomplete="new-password" />
        <button
          type="button"
          class="password-toggle-btn"
          (click)="togglePasswordVisibility('confirm')"
          [disabled]="submitting"
          [attr.aria-label]="showPasswordConfirm ? 'Ẩn nhập lại mật khẩu' : 'Hiện nhập lại mật khẩu'"
          [attr.aria-pressed]="showPasswordConfirm">
          <svg class="password-toggle-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path d="M2.5 12s3.5-7 9.5-7 9.5 7 9.5 7-3.5 7-9.5 7S2.5 12 2.5 12Z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" />
            <path d="M12 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z" fill="none" stroke="currentColor" stroke-width="1.8" />
            <path *ngIf="!showPasswordConfirm" d="M4 4l16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
          </svg>
        </button>
      </div>

      <div class="password-error" *ngIf="passwordNew && passwordConfirm && passwordNew !== passwordConfirm">Mật khẩu mới không khớp.</div>

      <div class="password-error" *ngIf="localError">{{ localError }}</div>
      <div class="password-error" *ngIf="hasError && errorMessage">{{ errorMessage }}</div>

      <div class="password-actions">
        <button type="button" class="button close-button" (click)="close()" [disabled]="submitting">Huỷ</button>
        <button
          type="button"
          class="save-button"
          (click)="save()"
          [disabled]="submitting || !passwordCurrent || !passwordNew || !passwordConfirm || !isPasswordNewStrong() || passwordNew !== passwordConfirm">
          <span *ngIf="!submitting">Lưu mật khẩu</span>
          <span *ngIf="submitting">Đang lưu...</span>
        </button>
      </div>
    </div>
  </section>
</div>
